import { render } from "./Cajas.vue?vue&type=template&id=70e6db68&scoped=true"
import script from "./Cajas.vue?vue&type=script&lang=js"
export * from "./Cajas.vue?vue&type=script&lang=js"

import "./Cajas.vue?vue&type=style&index=0&id=70e6db68&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70e6db68"]])

export default __exports__